export default {"src":"/_next/static/media/qual13.fa07fe11.svg","height":25,"width":14,"blurWidth":0,"blurHeight":0};